module.exports = __webpack_public_path__ + "static/media/neutral_face.92126eb3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/instore/icons/neutral_face.svg
// module id = 168
// module chunks = 0